import { BAR_NAME_MAX_LINES } from './chuva-chart-constants';

export const truncateLabel = (label: string, maxChars: number) => {
  if (label.length <= maxChars) return label;
  return `${label.slice(0, Math.max(1, maxChars - 1)).trimEnd()}…`;
};

export const wrapLabel = (label: string, maxChars: number) => {
  const lines: string[] = [];
  let current = '';

  label.split(/\s+/).forEach((word) => {
    const merged = current ? `${current} ${word}` : word;
    if (merged.length <= maxChars) {
      current = merged;
      return;
    }
    if (current) lines.push(current);
    current = word;
  });
  if (current) lines.push(current);
  if (lines.length === 0) return [''];
  if (lines.length <= BAR_NAME_MAX_LINES) {
    return lines.map((line) => truncateLabel(line, maxChars));
  }

  const kept = lines.slice(0, BAR_NAME_MAX_LINES);
  const rest = lines.slice(BAR_NAME_MAX_LINES).join(' ');
  kept[BAR_NAME_MAX_LINES - 1] = truncateLabel(
    `${kept[BAR_NAME_MAX_LINES - 1]} ${rest}`,
    maxChars,
  );
  return kept;
};

export const formatMm = (value?: number | null) =>
  value == null
    ? '-'
    : `${value.toLocaleString('pt-BR', { maximumFractionDigits: 1 })} mm`;
